import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-marketing-footer',
  templateUrl: './marketing-footer.component.html',
  styleUrls: ['./marketing-footer.component.scss']
})
export class MarketingFooterComponent {
  currentYear = new Date().getFullYear();

  constructor(private router: Router) {}

  navigateToStudents() {
    this.router.navigate(['/students']);
  }

  navigateToTeachers() {
    this.router.navigate(['/teachers']);
  }

  navigateToSchools() {
    this.router.navigate(['/schools']);
  }

  navigateToBusinesses() {
    this.router.navigate(['/businesses']);
  }

  onSubscribeNewsletter(email: string) {
    // TODO: Implement newsletter subscription functionality
    console.log('Newsletter subscription for:', email);
  }
}
